/**
 * OnboardingPublicoApiClient -- las peticiones del registro publico del cliente (OnboardPublicView), sin sesion.
 *
 * CONTRATO-VISTA-PANEL-T1 (familia fetch directo): la vista hacia 9 fetch a `${AppConfig.apiBase}/api/...`. Son las
 * mismas peticiones, movidas aqui; la vista sigue decidiendo con la Response (status, cuerpo, enlace vencido...).
 *
 * POR QUE NO VA POR ApiBase (TIPO-NEGOCIO-CANON-T1, Q #26828): la pagina no tiene sesion; un 401 en ApiBase cierra la
 * sesion y recarga, que aqui no tiene sentido, y sus escrituras no pasan por fetchQueCambia (no hay cache de sesion
 * que limpiar). Por eso check-reuso-api lo deja FUERA de su censo con esa razon.
 *
 * @module infrastructure/api/OnboardingPublicoApiClient
 */
import { AppConfig } from '../../config.js';

export const OnboardingPublicoApiClient = {
  /**
   * @param {string} ruta     desde /api/... (p. ej. '/api/v1/onboarding/pin')
   * @param {RequestInit} [opciones] las mismas del fetch de antes (method, headers, body)
   * @returns {Promise<Response>} la respuesta tal cual; lanza si no hay red (como antes)
   */
  pedir(ruta, opciones) {
    return fetch(`${AppConfig.apiBase}${ruta}`, opciones);
  }
};
